import React, { useEffect, useState, useRef } from "react";
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { AddIcon, Minus, Trash } from "../../assets";
import { BSON } from 'bson';
import { ArrowBackIos } from "@mui/icons-material";
import { AnimatedModal } from "..";
import { main_server } from "../../constants";

const colors = ['#55efc4', '#81ecec', '#74b9ff', '#a29bfe', '#00b894', '#00cec9', '#0984e3', '#6c5ce7', '#ffeaa7', '#fab1a0', '#ff7675', '#fd79a8', '#fdcb6e', '#e17055', '#d63031'];

  export default function Variations(props) {

    const [tickets, setTickets] = useState([]);
    const [selected, setSelected] = useState(0);
    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);

    const [minimized, setMinimized] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const messageRef = useRef();
  
  function formatMove(move) {
    if (move === undefined || move.san === undefined) return;
    if (!props.figure) return move.san;
    if (move.color === 'b') {
      return move.san.replace('N', '♘').replace('K', '♔').replace('R', '♖').replace('B', '♗').replace('Q', '♕');
    } else {
      return move.san.replace('N', '♞').replace('K', '♚').replace('R', '♜').replace('B', '♝').replace('Q', '♛');
    }
  }

     async function getTickets() {
          const ticketsReq = await fetch(main_server + "tickets", {
                   method: "GET",
                   headers: {
                     "Content-Type": "text/plain",
                     Authorization: "Bearer " + localStorage.getItem("chesscloud-token"),
                   },
                 });
           if (ticketsReq.status === 200) {
         try {
           const data = await ticketsReq.json();
           if (data === null) {
               console.log('DATA IS NULL');
               return;
           }
           setTickets(data);
       } catch (e) {
           console.log(e);
       }
       }
   }
  
   useEffect(() => {
      getTickets();
   }, [props.updateTickets]);

   const [open, setOpen] = useState([]);

  function Row(props: { row, dark, indx }) {
      const { row, dark, indx } = props
  
      return (
  <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset', background: props.dark ? '#2c3e50' : 'white' }}}>
          <TableCell>
            <IconButton
             sx={{color: props.dark ? 'white' : 'black'}}
              aria-label="expand row"
              size="small"
              onClick={() => {
                if (open.includes(row._id)) {
                    const tmp = open;
                    tmp.splice(tmp.indexOf(row._id), 1);
                    setOpen(tmp);
                } else {
                    setOpen([...open, row._id]);
                }
                setRefresh(refresh + 1);
              }}
            >
              {open.includes(row._id) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} component="th" scope="row">
            {row._id}
          </TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{(new Date(row.date)).toLocaleString()}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.topic}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.status === 0 ? 'Pending Response' : row.status === 1 ? 'Customer Action Required' : row.status === 2 ? 'Archived' : 'Closed'}</TableCell>
          <TableCell key={refresh} sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.status !== 3 && <ArrowBackIos onClick={() => { 
            if (minimized.includes(row._id)) {
              const tmp = minimized;
              minimized.splice(minimized.indexOf(row._id), 1);
                setMinimized(tmp);
             } else {
               setMinimized([...minimized, row._id]);
             }
             setRefresh(refresh + 1);
          }} style={{transform: `rotate(${minimized.includes(row._id) ? '90deg' : '-90deg'})`, cursor: 'pointer'}}/>}
          {minimized.includes(row._id) && 
          <div className="z-10 mt-[10px] ml-[-7px] border-white rounded-md border bg-gray-400 w-[100px] h-[100px] absolute mr-[10px] flex flex-col items-center justify-evenly">
            <AnimatedModal onClick={async () => {
              const message = messageRef.current.value;
              console.log(message);
              if (message.length > 3 && message.length <= 2048) {
                const res = await fetch(main_server + "message", {
                  method: "PUT",
                  headers: {
                    "Content-Type": "text/plain",
                    Authorization: "Bearer " + localStorage.getItem("chesscloud-token"),
                  },
                  body: JSON.stringify({ticket: row._id, message})
                });
                const tmp = tickets;
                tmp[indx].chat.push({message, sys: false, date: new Date()});
                setTickets(tmp);
                setRefresh(refresh + 1);
              }
            }} body={<>
              <p className="text-gray-400 text-lg mb-5 text-left w-full">Enter your reply below:</p>
              <textarea className="border border-gray-400 rounded pl-2 text-black" placeholder="Describe your issue here, you can use up to 2048 characters" ref={messageRef} />
              </>} showButton={true} applyText="Submit" index={11} trigger={<button className={`${props.dark ? 'text-white' : 'text-black'}`}>Reply</button>} />
            <AnimatedModal onClick={async () => {
              const res = await fetch(main_server + "close", {
                method: "POST",
                headers: {
                  "Content-Type": "text/plain",
                  Authorization: "Bearer " + localStorage.getItem("chesscloud-token"),
                },
                body: JSON.stringify({ticket: row._id})
              });
            document.getElementById('modalClose').click();
            const tmp = minimized;
              minimized.splice(minimized.indexOf(row._id), 1);
                setMinimized(tmp);
              const tmp2 = tickets;
              tmp2[indx].status = 3;
              setTickets(tmp2);
             setRefresh(refresh + 1);
            }} showButton={true} applyText="Close Ticket" body={<p className="text-gray-400 w-full text-left">Are you sure you want to close this ticket ? you will not be able to reply to it anymore.</p>} trigger={<button className={`${props.dark ? 'text-white' : 'text-black'}`}>Close Ticket</button>} />
            </div>}</TableCell>
        </TableRow>
        <TableRow sx={{'& > *': {background: props.dark ? '#2c3e50' : 'white'}}}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open.includes(row._id)} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
              <p className={`text-xl ${props.dark ? 'text-white' : 'text-black'}`}>Subject: {row.topic}</p>
              <p className="text-sm text-gray-400">Message: <span className={`${props.dark ? 'text-white' : 'text-black'}`}>{row.message}</span></p>
              <p className={`text-xl ${props.dark ? 'text-white' : 'text-black'}`}>Conversation:</p>
                {row.chat.map((msg) => (
                  <div className="w-full flex flex-col items-start justify-center">
                  <div style={{borderBottomColor: props.dark ? 'white' : 'black', borderBottomWidth: '0.01em'}} className="w-full flex flex-col items-start justify-center mt-[25px]">  
                  <p className={`text-gray-400`}>{msg.sys ? 'Chessmind Team:' : 'You:'} <span className={`${props.dark ? 'text-white' : 'text-black'}`}>{msg.message}</span></p>
                  <p className="text-gray-400">{(new Date(msg.date)).toLocaleString()}</p>
                  </div>
                  </div>
                ))}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
      )
  }

    return (
      <TableContainer sx={{width: '85%', marginLeft: '7.5%', marginTop: '50px'}} component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{background: props.dark ? '#2c3e50' : 'white'}}>
              <TableCell />
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} >ID</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Date</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Topic</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Status</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tickets.map((row, index) => (
              <Row key={index + refresh} indx={index} row={row} dark={props.dark} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
}